import {
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_REQUEST_SUCCESS,
  FORGOT_PASSWORD_REQUEST_FAILURE,
} from "./actionTypes";

const initialState = {
  isFetching: false,
  errorMessage: "",
  status: null,
 
};

export const Status = {
  FORGOT_PASSWORD_REQUEST: `forgot_password_request`,
  FORGOT_PASSWORD_REQUEST_SUCCESS: `forgot_password_request_success`,
  FORGOT_PASSWORD_REQUEST_FAILURE: `forgot_password_request_failure`,
};

const forgotPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case FORGOT_PASSWORD_REQUEST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        status: Status.FORGOT_PASSWORD_REQUEST_SUCCESS,
      };
    case FORGOT_PASSWORD_REQUEST_FAILURE:
      return {
        ...state,
        isFetching: false,
        status: Status.FORGOT_PASSWORD_REQUEST_FAILURE,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};

export const getIsFetchingState = (state) => state.forgotPassword.isFetching;
export const getErrorMessageState = (state) => state.forgotPassword.errorMessage;
export const getStatusState = (state) => state.forgotPassword.status;

export default forgotPasswordReducer;
